<script>
    import { Row, Col, Card, CardBody } from 'sveltestrap'
    import { createEventDispatcher } from 'svelte'
    import { InputText } from '@fno/component2/form.js'
    import { set } from 'dot-prop'

    export let context
    export let affiliation
    export let index

    let existingAffiliations = []

    $: {
        // we need to remove all other used keys, but KEEP the current key
        existingAffiliations = context.view.affiliations.map( ({ key }) => key).filter(key => key !== affiliation.key).filter(Boolean)
    }

    const dispatch = createEventDispatcher()

    function setAffiliationValue(event) {
        const value = event.detail.value

        // update the form, that will eventually get submitted as a PATCH request
        set(context, `form.affiliations.attributes.affiliations.${affiliation.key}`, value);

        // update the view, so all the other inputs know what is available
        const keyIndex = context.view.affiliations.findIndex(a => a.key === affiliation.key)
        set(context, `view.affiliations.${keyIndex}.value`, value)

        // update the changes, so the tooling knows that we need to make a PATCH request
        context.changes = context.changes || {}
        set(context, 'changes.affiliations', context.form.affiliations)

        // submit it all!
        dispatch('updateContext', {
            context
        })
    }
</script>

<Card class="mb-3">
    <CardBody>
        <Row>
            <Col xs="7">
                <InputText
                    label={`Affiliation Label #${index + 1}`}
                    disabled={!affiliation.key}
                    bind:value={affiliation.value}
                    on:change={setAffiliationValue}
                />
            </Col>
        </Row>
    </CardBody>
</Card>
